import {
  Box,
  Button,
  ButtonGroup,
  IconButton,
  TabProps,
} from "@chakra-ui/react";

import { useNavigate } from "react-router";

import { IQuickPin } from "../../routes/registries/stores/models/RegistryLayoutStore";
import { MaterialIcon } from "../shared/MaterialIcon";

interface IProps extends TabProps {
  quickPin: IQuickPin;
  onRemove: () => void;
}

export const QuickPin = ({ quickPin, onRemove }: IProps) => {
  const navigate = useNavigate();

  const handleOnClick = () => {
    if (quickPin.targetPath) {
      navigate(quickPin.targetPath);
    }
  };

  const handleOnRemoveQuickPin = () => {
    onRemove();
  };

  return (
    <Box>
      <ButtonGroup
        isAttached
        // variant="ghost"
        role={"group"}
        colorScheme="cyan"
      >
        <Button onClick={handleOnClick} mr="-px" color="white" bg="cyan.500">
          {quickPin.title}
        </Button>
        {/*  */}
        <IconButton
          _groupHover={{
            display: "block",
          }}
          display="none"
          bg="cyan.500"
          color="white"
          aria-label="Remove quick pin"
          onClick={handleOnRemoveQuickPin}
          icon={<MaterialIcon name="close" variant="outline" fontSize="1rem" />}
        ></IconButton>
        {/* Show when not hovered */}
        <IconButton
          _groupHover={{
            display: "none",
          }}
          bg="cyan.500"
          color="white"
          aria-label="Remove quick pin"
          icon={
            <MaterialIcon name="push_pin" variant="outline" fontSize="1rem" />
          }
        ></IconButton>
      </ButtonGroup>
    </Box>
  );
};
